import { ComponentFixture, TestBed } from '@angular/core/testing';

import { SafeGoComponent } from './safe-go.component';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SafeGo } from 'src/app/models/sale';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SafeGoService {
  apiUrl = 'v1/safeGo/';
  
  constructor(private http: HttpClient) { }

  public getSafeGo() {
    return this.http.get<SafeGo[]>(environment.ApiUrl() + this.apiUrl + "safeGo");
  }

  public sendSafeGoWhatsApp(orderId: number, safeGoStatus: number){
    const body = { orderId, safeGoStatus }
    return this.http.post(environment.ApiUrl() + this.apiUrl + `sendSafeGoWhatsApp`, body);
  }

  public verifySafeGo(orderId: number, safeGoPin: number) {
    const body = { orderId, safeGoPin };
    return this.http.post(environment.ApiUrl() + this.apiUrl + "verifySafeGo", body);
  }

  public removeUnverifiedSafeGo(safeGoTable: SafeGo[]) {
    return this.http.post(environment.ApiUrl() + this.apiUrl + "removeUnverifiedSafeGo", safeGoTable);
  }
}
